export default __webpack_public_path__ + "static/media/gallery_01.4d8fb30b.jpg";